/* ==========================================================================
   Noble Paw Co. — carruseles (estilo Haven)
   Flechas prev/next para cualquier [data-np-carousel] con un [data-np-track].
   El deslizamiento táctil es nativo (scroll-snap); este JS solo mueve con flechas
   y apaga la flecha que ya no tiene hacia dónde avanzar.
   ========================================================================== */
(function () {
  "use strict";

  function reduceMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function init(root) {
    if (!root || root.__npReady) return;
    var track = root.querySelector("[data-np-track]");
    if (!track) return;
    root.__npReady = true;
    var prev = root.querySelector("[data-np-prev]");
    var next = root.querySelector("[data-np-next]");

    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      var overflow = max > 0;
      root.classList.toggle("np-no-overflow", !overflow);
      if (prev) prev.disabled = !overflow || track.scrollLeft <= 2;
      if (next) next.disabled = !overflow || track.scrollLeft >= max;
    }

    function go(dir) {
      track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: reduceMotion() ? "auto" : "smooth" });
    }

    if (prev) prev.addEventListener("click", function () { go(-1); });
    if (next) next.addEventListener("click", function () { go(1); });
    track.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll("[data-np-carousel]").forEach(init);
  }

  /* Galería de producto: swipe en móvil, miniaturas en escritorio, puntos sincronizados */
  function initGallery(scope) {
    var gallery = (scope || document).querySelector("[data-np-gallery]");
    if (!gallery || gallery.__npReady) return;
    var slider = gallery.querySelector("[data-np-slider]");
    if (!slider) return;
    gallery.__npReady = true;

    var slides = [].slice.call(gallery.querySelectorAll("[data-np-slide]"));
    var dots = [].slice.call(gallery.querySelectorAll("[data-np-dot]"));
    var thumbs = [].slice.call(gallery.querySelectorAll("[data-np-thumb]"));
    if (slides.length < 2) return;

    var locked = false;
    var lockTimer;

    function setActive(i) {
      dots.forEach(function (d, k) { d.classList.toggle("is-active", k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle("is-active", k === i); });
    }

    /* Safari cancela el scroll suave contra scroll-snap y regresa a la 1ª foto:
       se apaga el snap, se salta (o se anima) y se vuelve a encender. */
    function goTo(i, instant) {
      var left = slides[i].offsetLeft - slides[0].offsetLeft;
      var jump = instant || reduceMotion();
      locked = true;
      clearTimeout(lockTimer);
      slider.style.scrollSnapType = "none";
      slider.scrollTo({ left: left, behavior: jump ? "auto" : "smooth" });
      setActive(i);
      lockTimer = setTimeout(function () {
        slider.scrollLeft = left;
        slider.style.scrollSnapType = "";
        locked = false;
      }, jump ? 80 : 520);
    }
    thumbs.forEach(function (t, i) { t.addEventListener("click", function () { goTo(i); }); });
    dots.forEach(function (d, i) { d.addEventListener("click", function () { goTo(i); }); });

    /* Al elegir una variante con foto propia, la galería salta a esa foto */
    var pdp = document.querySelector("[data-pdp]");
    var dataEl = pdp && pdp.querySelector("[data-variant-json]");
    if (pdp && dataEl) {
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
      var indexByMedia = {};
      slides.forEach(function (s, i) {
        var id = s.getAttribute("data-media-id");
        if (id) indexByMedia[id] = i;
      });

      var syncFromVariant = function () {
        var chosen = [].slice.call(pdp.querySelectorAll("[data-option-index]")).map(function (group) {
          var checked = group.querySelector("input:checked");
          return checked ? checked.value : null;
        });
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var match = v.options.length === chosen.length && v.options.every(function (o, k) { return o === chosen[k]; });
          if (match && v.media != null) {
            var idx = indexByMedia[String(v.media)];
            if (idx != null) goTo(idx, true);
            return;
          }
        }
      };

      /* click (no solo change): cubre Safari y los selectores con <label> */
      pdp.querySelectorAll("[data-option-index] input").forEach(function (input) {
        input.addEventListener("change", syncFromVariant);
        input.addEventListener("click", function () { setTimeout(syncFromVariant, 0); });
      });
    }

    var t;
    slider.addEventListener("scroll", function () {
      if (locked) return;
      clearTimeout(t);
      t = setTimeout(function () {
        var i = Math.round(slider.scrollLeft / slider.clientWidth);
        setActive(Math.max(0, Math.min(i, slides.length - 1)));
      }, 60);
    }, { passive: true });
  }

  document.addEventListener("DOMContentLoaded", function () { initAll(); initGallery(); });
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); initGallery(e.target); });
})();
